// 宠物App云套餐枚举字典
// 套餐没有「类型」字段，卖给哪些设备完全由 product_models（型号关联）决定

export const STATUS_OPTIONS = [
    { label: '测试', value: 0 },
    { label: '上架', value: 1 },
    { label: '下架', value: 2 },
    { label: '已删除', value: 3 }
]

export const TIME_UNITS = ['DAY', 'WEEK', 'MONTH', 'YEAR']

export const TAG_OPTIONS = [
    { label: '无标签', value: '' },
    { label: '推荐', value: 'recommended' },
    { label: '最划算', value: 'best_value' }
]

export const REGION_OPTIONS = ['cn', 'us', 'eu', 'sg']

// 试用天数上限（服务端校验 trial_days cannot exceed 365）
export const TRIAL_DAYS_MAX = 365

// 关套餐的退订方式：1 同时取消订阅（退款场景）／2 只关套餐、订阅继续扣款
export const EXIT_ORDER_OPTIONS = [
    { label: '同时取消订阅（退款）', value: 1 },
    { label: '只关套餐，订阅继续扣款', value: 2 }
]

// 配额型权益：item_value 必须是非负整数
export const QUOTA_FEATURES = [
    { key: 'feeding_plan_limit', name: '投喂计划条数上限' },
    { key: 'recording_limit', name: '自定义呼唤录音条数上限' },
    { key: 'history_days', name: '投喂历史回溯天数' },
    { key: 'camera_cloud_days', name: '摄像头云录像保留天数' },
    { key: 'ai_recognition', name: 'AI 识别开关（0/1）' }
]

export const QUOTA_KEYS = QUOTA_FEATURES.map(item => item.key)

export function statusText(value) {
    const item = STATUS_OPTIONS.find(status => status.value === value)
    return item ? item.label : '-'
}

export function tagText(value) {
    const item = TAG_OPTIONS.find(tag => tag.value === value)
    return item && value ? item.label : '-'
}

// 校验价格列表，返回错误信息，空串表示通过
export function validatePriceList(prices) {
    if (!prices.length) return '请至少添加一个币种价格'
    const currencies = prices.map(item => (item.currency || '').toUpperCase())
    if (currencies.some(item => !/^[A-Z]{3}$/.test(item))) return '请选择 3 位币种码'
    if (new Set(currencies).size !== currencies.length) return '币种不可重复'
    if (prices.some(item => item.price == null || item.sale_price == null)) return '请填写原价和售价'
    return ''
}

// 校验权益列表，返回错误信息，空串表示通过
export function validateFeatureList(features) {
    if (features.some(item => !item.item_key || item.item_value === '' || item.item_value == null)) {
        return '请填写权益 key 和值'
    }
    const keys = features.map(item => item.item_key)
    const duplicated = keys.find((key, index) => keys.indexOf(key) !== index)
    if (duplicated) return `权益项 ${duplicated} 重复`
    const invalid = features.find(item => QUOTA_KEYS.includes(item.item_key) && !/^\d+$/.test(String(item.item_value)))
    if (invalid) return `${invalid.item_key} 的值必须是非负整数`
    return ''
}

export function formatPrices(prices) {
    return prices.map(item => ({
        currency: item.currency.toUpperCase(),
        price: Number(item.price),
        sale_price: Number(item.sale_price)
    }))
}

export function formatFeatures(features) {
    return features.map(item => ({
        item_key: item.item_key,
        item_value: String(item.item_value),
        sort_order: Number(item.sort_order) || 0
    }))
}

// 基础信息表单的校验规则（创建/编辑共用）
export function baseRules() {
    return {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        service_time: [{ required: true, message: '请输入服务时长', trigger: 'blur' }],
        trial_days: [{
            validator: (rule, value, callback) => {
                const days = Number(value) || 0
                if (days < 0) return callback(new Error('试用天数不能为负数，填 0 表示不支持试用'))
                if (days > TRIAL_DAYS_MAX) return callback(new Error('试用天数不能超过 ' + TRIAL_DAYS_MAX + ' 天'))
                callback()
            },
            trigger: 'change'
        }]
    }
}

// 提交时的基础字段（与接口字段一一对应）
export function basePayload(form) {
    return {
        name: form.name,
        service_time: Number(form.service_time),
        service_time_unit: form.service_time_unit,
        cycles: Number(form.cycles) || 0,
        file_time: Number(form.file_time) || 0,
        trial_days: Number(form.trial_days) || 0,
        level: Number(form.level) || 0,
        tag: form.tag,
        sort_order: Number(form.sort_order) || 0,
        explain: form.explain
    }
}

export function formatTime(seconds) {
    if (!seconds) return '-'
    const date = new Date(seconds * 1000)
    const pad = n => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}
